import { Children, isValidElement } from 'react';

function getListChildren(children, name) {
  return Children.map(children, function (child) {
    var childElement = child;
    return childElement.type.displayName === name ? childElement : undefined;
  });
}

function getValidChild(type) {
  return function (child) {
    return /*#__PURE__*/isValidElement(child) ? child.type === type : false;
  };
}

export { getListChildren, getValidChild };